module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("4D3hi"))).then(() => parcelRequire('lWww0'));